import Analytics, { ACTION } from '../analytics/analytics';
import { METHOD, webRequest } from '../client/HttpClient';
import { API } from '../client/RouteConstants';

export const sendNotificationEmail = async (
    email: string,
    skuId: string,
    productId: string,
    customerNotifiableEvents: CustomerNotifiableEvents,
): Promise<NotificationEmailResponse> => {
    let success = false;
    const emailMeRequest = {
        productId: productId,
        skuId: skuId,
        email: email,
        customerNotifiableEvents: {
            backInStock: customerNotifiableEvents.backInStock,
            onRelease: customerNotifiableEvents.onRelease,
            onPreorderLaunch: customerNotifiableEvents.onPreorderLaunch,
            newlyInStock: customerNotifiableEvents.newlyInStock,
        },
    };

    try {
        const uri = `${process.env.REACT_APP_NOTIFICATION_HOST}${API.NOTIFICATION_EMAIL}`;
        const request: RequestInit = {
            method: METHOD.POST,
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(emailMeRequest),
        };
        const res = await webRequest(uri, request, false);
        if (res && res.ok) {
            Analytics.setProductIdOnJLData(productId);
            Analytics.dispatchAdobeAnalytics(ACTION.EMWBIS_SUBMITTED);
            success = true;
        }
    } catch {
        // silently swallow
    }

    return {
        success,
    };
};

interface NotificationEmailResponse {
    success: boolean;
}
